import checkCanStoreMedia from "./check-can-store-media.js";
import checkCanUpdateMedia from "./check-can-update-media.js";
import checkHasMediaStrategy from "./check-has-media-strategy.js";
import checkAwaitingSync from "./check-awaiting-sync.js";

export default {
	checkCanStoreMedia,
	checkCanUpdateMedia,
	checkHasMediaStrategy,
	checkAwaitingSync,
};
